import React from 'react';
import {View, Text} from 'react-native';
import {
   primaryState700,
   white,
   primaryColor500,
   FONT_FAMILY_REGULAR,
   isHoverEnabled,
   TabView_HOVER_COLOR,
} from '../../utils/utils';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {useSelector} from 'react-redux';

const TabView = ({isSelected, value}) => {
   const isLandscapemode = useSelector(selectScreenOrientation);
   const [isHover, setHover] = React.useState(false);
   return (
      <View
         onMouseEnter={() => {
            setHover(true);
         }}
         onMouseLeave={() => {
            setHover(false);
         }}
         style={{
            borderRadius: isLandscapemode ? 15 : 15,
            paddingVertical: isLandscapemode ? 8 : null,
            paddingHorizontal: isLandscapemode ? 16 : 8,
            marginEnd: 8,
            minWidth: 50,
            backgroundColor:
               isHover && isHoverEnabled
                  ? TabView_HOVER_COLOR
                  : isSelected
                  ? primaryColor500
                  : primaryState700,
            height: isLandscapemode ? 32 : 24,
            justifyContent: 'center',
            alignItems: 'center',
            gap: isLandscapemode ? 8 : null,
         }}>
         <Text
            style={{
               color: white,
               opacity: isSelected ? 1 : 0.6,
               fontSize: 10,
               fontWeight: '600',
               fontFamily: FONT_FAMILY_REGULAR,
            }}>
            {value}
         </Text>
      </View>
   );
};
export default TabView;
